var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckChargedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4582 22.2084L23.7394 11.9271L21.6978 9.88544L13.4582 18.125L9.30192 13.9688L7.26025 16.0104L13.4582 22.2084ZM15.4998 30.0834C13.4825 30.0834 11.5866 29.7005 9.81234 28.9349C8.03803 28.1693 6.49463 27.1302 5.18213 25.8177C3.86963 24.5052 2.83057 22.9618 2.06494 21.1875C1.29932 19.4132 0.916504 17.5174 0.916504 15.5C0.916504 13.4827 1.29932 11.5868 2.06494 9.81252C2.83057 8.03821 3.86963 6.49481 5.18213 5.18231C6.49463 3.86981 8.03803 2.83075 9.81234 2.06512C11.5866 1.2995 13.4825 0.916687 15.4998 0.916687C17.5172 0.916687 19.413 1.2995 21.1873 2.06512C22.9616 2.83075 24.505 3.86981 25.8175 5.18231C27.13 6.49481 28.1691 8.03821 28.9347 9.81252C29.7004 11.5868 30.0832 13.4827 30.0832 15.5C30.0832 17.5174 29.7004 19.4132 28.9347 21.1875C28.1691 22.9618 27.13 24.5052 25.8175 25.8177C24.505 27.1302 22.9616 28.1693 21.1873 28.9349C19.413 29.7005 17.5172 30.0834 15.4998 30.0834ZM15.4998 27.1667C18.7568 27.1667 21.5155 26.0365 23.7759 23.7761C26.0363 21.5156 27.1665 18.757 27.1665 15.5C27.1665 12.2431 26.0363 9.4844 23.7759 7.22398C21.5155 4.96356 18.7568 3.83335 15.4998 3.83335C12.2429 3.83335 9.48421 4.96356 7.2238 7.22398C4.96338 9.4844 3.83317 12.2431 3.83317 15.5C3.83317 18.757 4.96338 21.5156 7.2238 23.7761C9.48421 26.0365 12.2429 27.1667 15.4998 27.1667Z",
    fill: "url(#paint0_linear_281_43106)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_281_43106",
    x1: 0.916504,
    y1: 15.5,
    x2: 30.0832,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32ADE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckChargedback);
export default __webpack_public_path__ + "static/media/check-chargedback.f5b37e66f083ef3dd2a7d0b71bb19075.svg";
export { ForwardRef as ReactComponent };